import { render, staticRenderFns } from "./UserSelectDialog.vue?vue&type=template&id=20830bf7"
import script from "./UserSelectDialog.vue?vue&type=script&lang=js"
export * from "./UserSelectDialog.vue?vue&type=script&lang=js"
import style0 from "./UserSelectDialog.vue?vue&type=style&index=0&id=20830bf7&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/componenterpserver/gitrepo/unitmodeler/jp-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20830bf7')) {
      api.createRecord('20830bf7', component.options)
    } else {
      api.reload('20830bf7', component.options)
    }
    module.hot.accept("./UserSelectDialog.vue?vue&type=template&id=20830bf7", function () {
      api.rerender('20830bf7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/userSelect/UserSelectDialog.vue"
export default component.exports